module.exports = __webpack_public_path__ + "img/closeTag.93bc7ca7.svg";